module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-medium-pro-3d99709916c46d19181c717bb6e28174.eot";